// To support the priorities per project feature we need to use the /rest/api/3/priority/search endpoint instead: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-issue-priorities/#api-rest-api-3-priority-search-get
export const PRIORITY_SEARCH_API_ENDPOINT = '/rest/gira/1/';

export const ALL_PRIORITIES_DATA_OPERATION_NAME = 'BacklogCardListPrioritiesQuery';

export const ALL_PRIORITIES_QUERY = `
query ${ALL_PRIORITIES_DATA_OPERATION_NAME} ($projectIds: [ID!]!) {
    jira {
        jiraProjects(ids: $projectIds) {
          priorityScheme {
            priorities {
              edges {
                node {
                  priorityId
                  name
                  iconUrl
                }
              }
            }
          }
        }
      }
}
`;
